import { memo } from 'react'

interface IMicIconProps {
  size?: number
}

const MicIcon: React.FC<IMicIconProps> = memo(({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
  >
    <path
      d="M35.9994 44.021C33.1363 44.021 30.7258 43.0017 28.7679 40.9631C26.81 38.9245 25.8311 36.4491 25.8311 33.5368V10.1052C25.8311 7.29821 26.8193 4.91226 28.7958 2.94736C30.7722 0.982452 33.1722 0 35.9958 0C38.8193 0 41.2205 0.982452 43.1994 2.94736C45.1784 4.91226 46.1678 7.29821 46.1678 10.1052V33.5368C46.1678 36.4491 45.1889 38.9245 43.231 40.9631C41.2731 43.0017 38.8626 44.021 35.9994 44.021ZM35.9884 72C35.0905 72 34.3416 71.6974 33.7416 71.0921C33.1416 70.4868 32.8416 69.7368 32.8416 68.8421V59.4947C26.7573 58.7789 21.5678 56.3157 17.2731 52.1053C12.9784 47.8947 10.452 42.8315 9.69415 36.9157C9.54681 36.0105 9.79944 35.221 10.452 34.5473C11.1047 33.8737 11.9363 33.5368 12.9468 33.5368C13.6836 33.5368 14.3415 33.8158 14.9205 34.3736C15.4994 34.9315 15.8626 35.6 16.01 36.3789C16.7468 41.2631 18.9746 45.3263 22.6934 48.5685C26.4122 51.8105 30.8438 53.4316 35.9882 53.4316C41.1326 53.4316 45.5679 51.8105 49.2942 48.5685C53.0206 45.3263 55.2521 41.2631 55.9889 36.3789C56.1463 35.5895 56.5266 34.9184 57.1298 34.3658C57.7331 33.8132 58.4018 33.5368 59.1362 33.5368C60.1327 33.5368 60.9468 33.8737 61.5784 34.5473C62.21 35.221 62.4521 36.0105 62.3047 36.9157C61.5468 42.8315 59.0205 47.8947 54.7258 52.1053C50.4311 56.3157 45.2416 58.7789 39.1573 59.4947V68.8421C39.1573 69.7368 38.8536 70.4868 38.2462 71.0921C37.6388 71.6974 36.8862 72 35.9884 72Z"
      fill="currentColor"
    />
  </svg>
))

export { MicIcon }
